import React, {useState, useEffect} from "react";
import {CollectionsDashboard} from "../organisms/CollectionsDashboard";
import {ProfileForm} from "../organisms/ProfileForm";
import WorklistSettings from "../organisms/CollectionSettings";
import DefaultWrapper from "./DefaultWrapper";

interface IProps {
    client: any;
    widgetOptions: any;
    directoryType: string;
    setDirectoryType: (directoryType: string) => void;
}

export default function QueueSettings(props: IProps) {
    const { client, widgetOptions, directoryType, setDirectoryType } = props;

    const [showDetails, setShowDetails] = useState(false);
    const [selected, setSelected] = useState({});

    useEffect(() => {
        // @ts-expect-error DD_RUM is not declared on the window type
        (directoryType !== undefined) && window.DD_RUM && window.DD_RUM.startView(`Open Queue settings ${directoryType}`);
    }, [directoryType]);

    const showForm = (profile: any, show: boolean) => {
        setSelected(profile);
        setShowDetails(show);
    };

    const queueProfile = () => {
        return (
            <>
                {showDetails ? (
                    <ProfileForm
                        client={client}
                        showForm={showForm}
                        existingProfile={selected}
                    />
                ) : (
                    <WorklistSettings
                        DirectoryType={directoryType}
                        client={client}
                        showForm={showForm}
                    />
                )}
            </>
        );
    };

    const workerCollection = () => {
        return (
            <WorklistSettings
                DirectoryType={directoryType}
                client={client}
                setShowDetails={setShowDetails}
            />
        );
    };
    
    return (
        <DefaultWrapper>
            <CollectionsDashboard
                queueProfile={queueProfile}
                coderDistribution={workerCollection}
                setDirectoryType={setDirectoryType}
                showDetails={showDetails}
                setShowDetails={setShowDetails}

                tabs={[
                    { label: "Queues", value: "collection" },
                    { label: "Distribution", value: "distribution" },
                ]}
            />
        </DefaultWrapper>
    );
}
